// Colors
export const BLACK = 'rgba(10, 11, 12, 1)';
export const BLACK_05 = 'rgba(10, 11, 11, 0.05)';
export const BLACK_10 = 'rgba(10, 11, 12, 0.1)';
export const BLACK_20 = 'rgba(10, 11, 11, 0.2)';
export const BLACK_30 = 'rgba(10, 11, 11, 0.3)';
export const BLACK_40 = 'rgba(10, 11, 12, 0.4)';
export const BLACK_50 = 'rgba(10, 11, 11, 0.5)';
export const BLACK_60 = 'rgba(10, 11, 11, 0.6)';
export const BLACK_70 = 'rgba(10, 11, 11, 0.7)';
export const BLACK_80 = 'rgba(10, 11, 11, 0.8)';
export const BLACK_90 = 'rgba(10, 11, 11, 0.9)';

export const GRAY1 = 'rgba(244, 245, 244, 1)';
export const GRAY2 = 'rgba(240, 240, 240, 1)';
export const GRAY3 = 'rgba(231, 232, 232, 1)';
export const GRAY4 = 'rgba(200, 202, 203, 1)';
export const GRAY5 = 'rgba(157, 160, 162, 1)';
export const GRAY6 = 'rgba(113, 118, 120, 1)';
export const GRAY7 = 'rgba(72, 75, 77, 1)';

export const GREEN = 'rgba(0, 178, 120, 1)';
export const GREEN_10 = 'rgba(0, 178, 120, 0.1)';
export const GREEN_30 = 'rgba(0, 178, 120, 0.3)';
export const GREEN_50 = 'rgba(0, 178, 120, 0.5)';
export const GREEN_DARK = 'rgba(0, 108, 73, 1)';

export const PURPLE = 'rgba(103, 117, 226, 1)';
export const PURPLE_20 = 'rgba(103, 117, 226, 0.2)';
export const PURPLE_DARK = 'rgba(86, 67, 203, 1)';

export const WHITE = 'rgba(255, 255, 255, 1)';
export const WHITE_10 = 'rgba(255, 255, 255, 0.1)';
export const WHITE_20 = 'rgba(255, 255, 255, 0.2)';
export const WHITE_50 = 'rgba(255, 255, 255, 0.5)';
export const WHITE_85 = 'rgba(255, 255, 255, 0.85)';

export const BLUR_WHITE = 'rgba(255, 255, 255, 0.85)';
export const BLUR_GREY = 'rgba(242, 242, 242, 0.5)';
export const BLUR_BLACK = 'rgba(10, 11, 12, 0.85)';

export const RED = 'rgba(224, 54, 0, 1)';
export const RED_10 = 'rgba(224, 54, 0, 0.1)';

export const ORANGE_LIGHT = 'rgba(245, 180, 7, 1)';
export const ORANGE = 'rgba(255, 147, 15, 1)';
export const ORANGE_DARK = 'rgba(235, 131, 4, 1)';
export const BLUE = 'rgba(0, 170, 255, 1)';
export const YELLOW = 'rgba(255, 232, 149, 1)';
export const YELLOW_LIGHT = 'rgba(255, 248, 222, 1)';
export const BEIGE_LIGHT = 'rgba(250, 246, 237, 1)';

// Media queries
export const mq = {
  xl: '@media screen and (max-width: 1280px)',
  lg: '@media screen and (max-width: 1120px)',
  md: '@media screen and (max-width: 1024px)',
  sm: '@media screen and (max-width: 768px)',
  xs: '@media screen and (max-width: 480px)',
};
